var _g, _g2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    width: "34px",
    height: "34px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chart--histogram_1_",
    d: "M31,31.36H1c-0.199,0-0.36-0.161-0.36-0.36V1h0.72v14.632c3.704-0.168,5.584-2.933,7.405-5.609 c1.8-2.646,3.662-5.382,7.235-5.382s5.436,2.736,7.235,5.382c1.879,2.762,3.821,5.618,7.765,5.618v0.72 c-4.324,0-6.376-3.016-8.36-5.933C20.867,7.822,19.192,5.36,16,5.36c-3.193,0-4.867,2.461-6.64,5.067 c-1.928,2.834-3.92,5.763-8,5.926V30.64h2.28V20c0-0.199,0.161-0.36,0.36-0.36h3.64V16c0-0.199,0.161-0.36,0.36-0.36h3.64V11 c0-0.199,0.161-0.36,0.36-0.36h4c0.199,0,0.36,0.161,0.36,0.36v1.64H20c0.199,0,0.36,0.161,0.36,0.36v3.64H24 c0.199,0,0.36,0.161,0.36,0.36v4.64H28c0.199,0,0.36,0.161,0.36,0.36v8.64H31V31.36z M24.36,30.64h3.279v-8.28H24.36V30.64z M20.36,30.64h3.279V17.36H20.36V30.64z M16.36,30.64h3.28V13.36h-3.28V30.64z M12.36,30.64h3.28V11.36h-3.28V30.64z M8.36,30.64 h3.28V16.36H8.36V30.64z M4.36,30.64h3.28V20.36H4.36V30.64z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle",
    style: {
      fill: "none"
    },
    width: 32,
    height: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.df5c0ebe241b438c40452203ced43b88.svg";
export { ForwardRef as ReactComponent };